import { Grid, Box } from '@chakra-ui/react'
import { FC, useEffect, useMemo } from 'react'

import useOptimizerStorange from '@hook/optimizer/use-optimizer-storange'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import Layout from '@component/Layout'
import LayoutEmpty from '@component/Layout/Empty'
import LayoutFilters from '@component/Layout/Filters'
import LayoutLoader from '@component/Layout/Loader'
import LayoutTools from '@component/Layout/Tools'
import Otimizador from '@component/Modules/Optimizer/Storange/GraphOne'

import { disableActionsByDefault } from '@helper/parametrization/disableActionsByDefault'
import { validateAppVersion } from '@helper/util/storangeClear'
import generic from '@service/generic'

const ParametrizationSupply: FC = () => {
  const { menuToggle } = useLayout()
  const { getFilters } = useFilters()
  const {
    loading,
    dataTradeOffEstoque,
    filename,
    params,
    handleLocalParams,
    filters,
    setFilters,
    filtersList,
    fetching,
    query,
    actions,
    getCenters,
    getData,
    setFilename,
    clearAllFilters,
    handleUpdateParams
  } = useOptimizerStorange()

  const { hasSessions } = useSessions()

  const height = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 30px)'
          : '100vh'
        : hasSessions
        ? 'calc(100vh - 160px)'
        : 'calc(100vh - 142px)',
    [menuToggle, hasSessions]
  )
  useEffect(() => {
    getCenters()
    handleLocalParams()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getCenters])

  useEffect(() => {
    generic
      .getMaintence('manutencao')
      .then(({ data: { data } }) => {
        validateAppVersion(data.version)

        if (data.valor === 'true') {
          window.location.href = '/manutencao'
        } else {
          const loadFilters = async () => {}

          loadFilters()
          getFilters({
            centerTypes: true,
            companies: true,
            centers: true,
            worlds: true,
            compactCategories: true,
            abcCurves: true,
            subCategories: true
          })
        }
      })
      .catch(() => {})

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getFilters])
  return (
    <Layout title="Otimizador">
      <Grid
        w="100vw"
        bg="white"
        h={height}
        templateColumns={!filters ? '100vw' : '260px calc(100vw - 260px)'}
      >
        {filters && (
          <LayoutFilters
            filters={filtersList}
            values={params}
            onChange={handleUpdateParams}
            loading={loading}
            canCancel={fetching}
            onFilter={getData}
            onClearAllFilters={clearAllFilters}
          />
        )}
        <Box>
          <LayoutTools
            title={filename}
            filters={filters}
            actions={actions}
            query={query}
            // onSearchChange={setQuery}
            onTitleChange={setFilename}
            toggleFilters={setFilters.toggle}
            isDisabled={false}
            disableActionsByDefault={disableActionsByDefault}
          />
          {loading ? (
            <LayoutLoader
              title="Recuperando informações..."
              message="Aguarde enquanto buscamos os dados no banco de dados"
            />
          ) : dataTradeOffEstoque === null ? (
            <LayoutEmpty
              title="Nada encontrado!"
              message="Filtre sua busca ao lado para obter informações"
            />
          ) : (
            <Box
              h="auto"
              maxH={['20vh', '50vh', '55vh', '70vh', '70vh', '75vh']}
              overflow="auto"
            >
              <Otimizador />
            </Box>
          )}
        </Box>
      </Grid>
    </Layout>
  )
}

export default ParametrizationSupply
